import { Box, styled } from "@mui/material";
import { colors } from '../../../../theme/colors';

export const MainWrapper = styled(Box)({
  "& table": {
    // minWidth: "1500px",
  },
  "& .MuiTableCell-head": {
    color: "#fff !important",
    fontSize: "13.5px",
    fontWeight: 600,
    backgroundColor: colors.primary,
    backgroundImage: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
    whiteSpace: "nowrap",
    letterSpacing: "0.3px",
    padding: "14px 16px",
  },
  "& .table_user-primary-detail": {
    display: "flex",
    gap: 10,
    alignItems: "center",
    "& > div > p": {
      fontSize: "0.875rem",
      "&:nth-of-type(2)": {
        color: "#919EAB",
      },
    },
  },
  "& .MuiAvatar-root": {
    width: 35,
    height: 35,
  },
  "& label.Mui-focused": {
    color: colors.primary,
    fontWeight: 600,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "rgba(145, 158, 171, 0.5)",
      borderRadius: "10px",
      transition: "border-color 0.2s ease",
    },
    "&:hover fieldset": {
      borderColor: "rgba(145, 158, 171, 0.85)",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.primary,
      borderWidth: "2px",
    },
  },
  "& .btn": {
    backgroundColor: colors.primary,
    color: "#fff",
    borderRadius: "8px",
    textTransform: "capitalize",
    padding: "8px 20px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      color: "#fff",
      boxShadow: `0 4px 12px ${colors.primary}44`,
    },
  },

  "& .btn.Mui-disabled": {
    backgroundColor: colors.buttonDisabled.background,
    color: colors.buttonDisabled.color,
    opacity: 1,
    cursor: "not-allowed",
  },
  "& .MuiTableBody-root .MuiTableRow-root": {
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: colors.sidebarHover,
    },
  },
  "& .custom-scrollbar": {
    marginBottom: "20px",
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "lightgray",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: colors.primary,
      borderRadius: "10px",
      border: "2px solid lightgray",
    },
  },
  "& .delete-btn": {
    backgroundColor: colors.primary,
    color: "#fff",
    ":hover": {
      backgroundColor: colors.primary,
    },
  },

  "& .filter-container": {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "16px",
  },
  "& .filter-controls": {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    alignItems: "center",
  },
  "& .search-field": {
    flex: 1,
    minWidth: "200px",
  },
  "& .rows-per-page-select": {
    minWidth: "200px",
  },
  "& .table-container": {
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  "& .action-buttons-container": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.4rem",
  },
  "& .edit-button": {
    color: colors.primary,
    border: `1px solid ${colors.primaryLightBorder}`,
    borderRadius: "8px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primary,
      color: "#fff",
      borderColor: colors.primary,
    },
    "&.Mui-disabled": {
      border: "1px solid #e5e7eb",
      opacity: 0.5,
    },
  },
  "& .delete-button": {
    color: "#dc2626",
    border: "1px solid #fca5a5",
    borderRadius: "8px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#dc2626",
      color: "#fff",
      borderColor: "#dc2626",
    },
    "&.Mui-disabled": {
      border: "1px solid #e5e7eb",
      opacity: 0.5,
    },
  },
  "& .icon-large": {
    fontSize: "large",
  },
  "& .custom-tooltip": {
    backgroundColor: colors.primary,
    color: "#fff",
    fontSize: "0.875rem",
  },
  "& .custom-tooltip-arrow": {
    color: colors.primary,
  },
  "& .pagination-container": {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
});
